import React, { useState, useEffect, Fragment } from "react";
import { fetchJson } from "../../lib/Fetching";
import QuotablesGroup from "./QuotablesGroup";

export default function SampleAttemptQuotables({
  attemptId,
  sampleId,
  clientSuiteId,
  clientSpecificationId,
  onChangeQuoteItems,
  disabledQuoteItemIds,
  selectedQuoteItemIds,
  companyId,
  matrixId,
}) {
  const [quotables, setQuotables] = useState(null);

  useEffect(
    () => {
      fetchJson("/quoting/quotables/additional_testing.json", {
        sample_id: sampleId,
        client_suite_id: clientSuiteId,
        attempt_id: attemptId,
        client_specification_id: clientSpecificationId,
        company_id: companyId,
        matrix_id: matrixId,
      }).then((json) => {
        setQuotables(json.quotables);
      });
    },
    [sampleId || clientSuiteId]
  );

  return (
    <Fragment>
      {quotables ? (
        <QuotablesGroup
          selectQuoteItems
          quotables={quotables}
          disabledIds={disabledQuoteItemIds}
          selectedIds={selectedQuoteItemIds}
          onChangeIds={onChangeQuoteItems}
        />
      ) : (
        <p>
          <i class="fa fa-spinner fa-spin" />
          &nbsp; Loading quote details...
        </p>
      )}
    </Fragment>
  );
}
